<template>
  <el-dialog :close-on-click-modal="false" append-to-body title="编辑产品" :visible.sync="editProDialog" width="1000px">
    <el-form ref="form" label-width="150px">
      <el-form-item label="产品类别">
        <el-select v-model="addPosSpuVO.firstCategoryId" placeholder="请选择" @change="(e) => getSecondCategoryList(e, true)" style="margin-right:5px;">
          <el-option v-for="item in firstCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
        </el-select>
        <el-select v-model="addPosSpuVO.secondCategoryId" placeholder="请选择">
          <el-option v-for="item in secondCategoryList" :key="item.categoryId" :label="item.categoryName" :value="item.categoryId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品名称">
        <el-input v-model="addPosSpuVO.spuName"></el-input>
      </el-form-item>
      <el-form-item label="价格信息:">
        <el-table border :data="skuGroupDate" @expand-change="expandChange" style="width: 880px;float: right">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table :data="scope.row.skuDate" border style="width: 100%">
                <el-table-column label="SKU名称" prop="skuName"></el-table-column>
                <el-table-column label="基础P数" prop="basePage"></el-table-column>
                <el-table-column label="最大P数" prop="maxPage"></el-table-column>
                <el-table-column label="一次增加P数" prop="baseStep"></el-table-column>
                <el-table-column label="基础P平台价格" prop="basePagePrice"></el-table-column>
                <el-table-column label="增加一次平台价格" min-width="130px" prop="baseStepPrice"></el-table-column>
                <el-table-column label="基础P在线支付价格" min-width="130px" prop="onlineSalePrice"></el-table-column>
                <el-table-column label="增加一次在线支付价格" min-width="130px" prop="onlineBaseStepPrice"></el-table-column>
                <el-table-column label="基础P推荐终端价格" min-width="130px" prop="b2BTerminalSalePrice"></el-table-column>
                <el-table-column label="增加一次推荐终端价格" min-width="130px" prop="b2BTerminalStepSalePrice"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="SKU组" prop="skuGroupName"></el-table-column>
          <el-table-column label="属性组和" prop="dictSet"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color_blue" v-show="scope.row.onSale">上架</span>
              <span class="color_blue" v-show="!scope.row.onSale">下架</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="产品主图">
        <!-- <div class="product-img ql-editor" v-html="productInfoDate.spuImage"></div> -->
        <el-image v-for="img in productInfoDate.spuImageList" :key="img" style="width: 100px; height: 100px" :src="img + '?x-sds-process=image/resize,l_98,m_mfit'"
          :preview-src-list="productInfoDate.spuImageList">
        </el-image>
      </el-form-item>
      <el-form-item label="PC产品详情">
        <div class="product-img ql-editor" v-html="productInfoDate.pcDetail"></div>
      </el-form-item>
      <el-form-item label="手机产品详情">
        <div class="product-img ql-editor" v-html="productInfoDate.phoneDetail"></div>
      </el-form-item>
      <el-form-item>
        <el-button round @click="editPro()">保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

import { posSpuUpdate, categoryList, posCategoryQueryAllSubs, posCategoryList, prodductInfo, getSku } from '@/api/pms'

export default {
  data () {
    return {
      tagsId: '',
      firstCategoryList: [],
      secondCategoryList: [],
      productInfoDate: {},
      addPosSpuVO: {
        firstCategoryId: '',
        secondCategoryId: '',
        skuGroups: [
          {
            isSample: true,
            skuGroupId: 0
          }
        ],
        spuId: 0,
        spuName: '',
        tagsId: 0
      },
      skuGroupDate: [],
      spuVO: {
        spuName: '',
        categoryId: ''
      },
      editProDialog: false,
      defaultProps: {
        children: 'children',
        label: 'label',
        isLeaf: 'leaf'
      },
      queryInfo: {
        pageNum: 1,
        pageSize: 24,
        total: 0
      },
      selectRowDate: {} // 选中的skuGrouop
    }
  },
  methods: {
    show (rowDate) {
      this.tagsId = rowDate.tagsId
      this.addPosSpuVO.spuId = rowDate.spuId
      this.editProDialog = true
      this.getFirstCategoryList()
      this.getProdductInfo(rowDate.spuId)
    },
    hide () {
      this.editProDialog = false
    },
    editPro () {
      let addPosSpuVO = {
        firstCategoryId: this.addPosSpuVO.firstCategoryId,
        secondCategoryId: this.addPosSpuVO.secondCategoryId,
        skuGroups: this.productInfoDate.skuGroupList.reduce((list, item) => {
          list.push({
            isSample: item.onSale,
            skuGroupId: item.id
          })
          return list
        }, []),
        spuId: this.addPosSpuVO.spuId,
        spuName: this.addPosSpuVO.spuName,
        tagsId: this.tagsId
      }
      posSpuUpdate(addPosSpuVO)
        .then(res => {
          if (res.data.success) {
            this.$message.success('编辑成功')
            this.editProDialog = false
            this.$emit('fatherMethod')
          }
        })
    },
    getSecondCategoryList (value, a) {
      posCategoryQueryAllSubs(value).then(res => {
        if (res.data.success) {
          this.secondCategoryList = res.data.data.subCategoryList
          if (a) {
            this.addPosSpuVO.secondCategoryId = this.secondCategoryList.length === 0 ? '' : this.secondCategoryList[0].categoryId
          }
        }
      })
    },
    getFirstCategoryList () {
      posCategoryList(this.tagsId)
        .then(res => {
          if (res.data.success) {
            this.firstCategoryList = res.data.data
          }
        })
    },
    getProdductInfo (val) {
      prodductInfo(val).then(res => {
        if (res.data.success) {
          this.productInfoDate = res.data.data
          this.addPosSpuVO.firstCategoryId = this.productInfoDate.topCategoryId
          this.addPosSpuVO.secondCategoryId = this.productInfoDate.categoryId
          this.addPosSpuVO.spuName = this.productInfoDate.spuName
          this.getSecondCategoryList(this.productInfoDate.topCategoryId)

          this.skuGroupDate = this.productInfoDate.skuGroupList.reduce((list, item) => {
            getSku(item.skuGroupId).then(res => {
              if (res.data.success) {
                item.skuDate = res.data.data
              }
            })
            list.push(item)
            return list
          }, [])
        }
      })
    },
    expandChange (row, expandRows) {
      this.selectRowDate = row
      if (row.skuDate.length === 0) {
        getSku(row.skuGroupId).then(res => {
          if (res.data.success) {
            row.skuDate = res.data.data
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-container {
  height: 500px;

  .el-aside {
    border-right: 1px solid #ccc;
    width: 180px;
  }
}

.pro_box {
  // width: 98px;
  float: left;
  border: 1px solid #ccc;
  margin-right: 20px;
  margin-bottom: 10px;
  cursor: pointer;

  &:nth-of-type(6n) {
    margin-right: 0px;
  }

  p {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
